import { Box, CircularProgress } from '@mui/material';

/**
 * Suspense fallback for a lazily loaded route. Shown for the few hundred
 * milliseconds it takes to fetch a page's chunk the first time it is opened.
 */
export function RouteLoading() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', p: 6 }}>
      <CircularProgress />
    </Box>
  );
}
